// extracted by mini-css-extract-plugin
module.exports = {"caution":"UnconfirmBonusModal__caution--1jzQn"};